import type { BusTopology } from "@neoweb/audio";

// The hockey mixer graph: master → soft limiter → speakers, with categorised SFX subgroups so the
// mix can be ducked by category (e.g. crowd during a goal call) without touching individual sounds.
export const busTopology: BusTopology = {
  buses: [
    { id: "master", parent: "destination", gain: 1 },
    { id: "sfx", parent: "master", gain: 0.8 },
    { id: "sfx.puck", parent: "sfx" },
    { id: "sfx.body", parent: "sfx" },
    { id: "sfx.goalie", parent: "sfx" },
    { id: "sfx.skates", parent: "sfx" },
    { id: "crowd", parent: "master", gain: 0.5 },
    { id: "ui", parent: "master", gain: 0.9 },
  ],
  // Gentle compressor on master prevents clipping when many voices stack.
  masterCompressor: { threshold: -10, knee: 30, ratio: 4, attack: 0.005, release: 0.1 },
};
